import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "page-section portfolio",
  id: "portfolio"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><h2 class=\"page-section-heading text-center text-uppercase text-secondary mb-0\">Projekty</h2><div class=\"divider-custom\"><div class=\"divider-custom-line\"></div><div class=\"divider-custom-icon\"><i class=\"fas fa-code\"></i></div><div class=\"divider-custom-line\"></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 text-center\"><h1>Pracuje se na tom.</h1></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}